import React, { useState, useEffect } from "react";
import { Form, Modal, Row, Col, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AuthServiceV2 from "../../services/auth.serviceV2";
import Static_modal from "../user/etc/Static_modal";

//icon

import { IoNewspaper } from "react-icons/io5";
import { FaUserTie } from "react-icons/fa6";
import { LiaUsersSolid } from "react-icons/lia";
import { MdSettingsRemote , MdFolderSpecial } from "react-icons/md";
import PersonIcon from "@mui/icons-material/Person";
import BadgeIcon from "@mui/icons-material/Badge";
import { PiCertificateDuotone } from "react-icons/pi";
import { GiDeliveryDrone, GiPlanetConquest } from "react-icons/gi";
import LogoutIcon from "@mui/icons-material/Logout";

/// Child pages
import Userpage from "./ProfileUser/mypage1";
import UserInformation from "./ProfileUser/mypage2";
import DroneList from "./ProfileUser/mypage3_1";
import RemoteID_List from "./ProfileUser/mypage3_2";
import AffiliatedPilot from "./ProfileUser/mypage3_3";
import PilotManagement from "./ProfileUser/mypage4";
import MyOperation from "./ProfileUser/mypage5_1";
import SpecialOperation from "./ProfileUser/mypage5_2";
import CertificateManager from "./ProfileUser/mypage6";
/// Child pages

function ProfileUser() {
  const Navigate = useNavigate();
  const [articlePage, setArticlePage] = useState(1);
  const [sideNavTree, setsideNavTree] = useState(0);
  const [sideNavSelection, setSideNavSelection] = useState(1);
  const [loading, setLoading] = useState(true);
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
 
  //User Status
  const [pilotStatus, setPilotStatus] = useState(false);
  const [operatorStatus, setOperatorStatus] = useState(false);

  const [textBody, setTextBody] = useState();
  //infomation
  const [droneData, setDroneData] = useState([""]);
  const [data, setData] = useState("");
  //infomation

  const [shownoregisdrone, setShownoregisdrone] = useState(false);
  const [remoteID_Data, setRemoteID_Data] = useState([]);
  const [corporation, setCorporation] = useState(undefined);
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };
  function handleSideNavPage(navTree,page,sideNavSelection) {
    try{
      setsideNavTree(navTree);
    setArticlePage(page);
    setSideNavSelection(sideNavSelection);
    }catch(e){
      setTextBody("Nav Selection เกิดข้อผิดพลาด");
      setModalToggle({ ...modalToggle, modalErr: true });
    }

  }
  function handleLogout() {
    try{
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      sessionStorage.removeItem("access_token");
      sessionStorage.removeItem("refresh_token");
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("type_user");
      sessionStorage.removeItem("pilot_id");
      sessionStorage.removeItem("pilot_code_open");
      sessionStorage.removeItem("pilot_code_specific");
      sessionStorage.removeItem("operator_id");
      sessionStorage.removeItem("operator_code");
      Navigate("/login");
      window.location.reload();
    }catch(e){
      setTextBody("Logout เกิดข้อผิดพลาด");
      setModalToggle({ ...modalToggle, modalErr: true });
    }
  };


  useEffect(() => {
    const checktype = sessionStorage.getItem("type_user");
    const Ispilot = sessionStorage.getItem("pilot_id");
    const Isoperator = sessionStorage.getItem("operator_id");
    console.log(typeof Ispilot);
    if (Ispilot&&Ispilot!=="null") {setPilotStatus(true);}
    if (Ispilot&&Isoperator!=="null") {setOperatorStatus(true);}
    if (checktype === "corporation") {
      const checkcorpertation = AuthServiceV2.corporationdata();
      if (checkcorpertation != null) {
        checkcorpertation.then(function (result) {
          setCorporation(result.data.data);
          console.log(result);
        }).catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });

        })
      }
    } else {
      const check = AuthServiceV2.getCurrentUser();
      if (check != null)
        check.then(function (result) {
          if (result.data.code === "GDS") {
            console.log(result.data.code);
            const data1 = AuthServiceV2.getCurrentUser();
            if (data1 != null)
              data1.then(function (result) {
                setData(result.data.data);
                console.log(result);
              }).catch((error) => {
                setTextBody(error);
                setModalToggle({ ...modalToggle, modalErr: true });

              })
          } else {
            console.log("passPNS");
            const data1 = AuthServiceV2.getCurrentUser();
            if (data1 != null)
              data1.then(function (result) {
                setData(result.data.data);
                console.log(result);
              }).catch((error) => {
                setTextBody(error);
                setModalToggle({ ...modalToggle, modalErr: true });

              })
          }
        }).catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });

        })
    }
  }, []);

  ///Fetch Data
  async function FetchOperatorDrone() {
    try{
      const check = AuthServiceV2.getoperatordrone();
      if (check != null) {
        check.then((response) => {
          console.log(response);
          if (response.data.dronedata === "No drone registered") {
            // setShownoregisdrone(true);
            setTimeout(() => {
              setShownoregisdrone(false);
            }, 2000);
          } else {
            console.log("Drone", response.data.dronedata);
            setDroneData(response.data.dronedata);
          }
        }).catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });

        })
      }
    }catch(e){
      setTextBody("FetchOperatorDrone เกิดข้อผิดพลาด");
      setModalToggle({ ...modalToggle, modalErr: true });
    }
  }
  async function FetchOperatorRemote() {
    try{
      const check2 = AuthServiceV2.getoperatorremote();
      if (check2 != null) {
        check2.then((response) => {
          console.log(response);
          if (response.data.dronedata === "No reomte id registered") {
          } else {
            setRemoteID_Data(response.data.dronedata);
          }
        }).catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });

        })
      
      }
    }catch(e){
      setTextBody("FetchOperatorRemote เกิดข้อผิดพลาด");
      setModalToggle({ ...modalToggle, modalErr: true });
  }
}
useEffect(() => {
  const fetchData = async () => {
    await FetchOperatorDrone();
    await FetchOperatorRemote();
  };

  fetchData();
  setTimeout(() => {
    setLoading(false);
  }, 1000);
}, []);

 
  return (
    <div>
      {loading && (
        <div className="loading-container">
          {" "}
          <Spinner animation="border" variant="secondary" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
      {!loading && (data || corporation) && (
        <div style={{}}>
          <div className="profile-container">
            <div className="profile-side-nav">
              <div className="nav-side-body">
                <ul className="nav-side-menu">
                  <li style={{ cursor: "pointer" }}>
                    <a
                      className="nav-sidemenu-selection"
                      style={{ color: sideNavSelection === 1&&sideNavTree===0 ? "#4d6368 " : "" }}
                      onClick={()=>{handleSideNavPage(0,1,1)}}
                    >
                      <i>
                        <PersonIcon style={{ width: "25px", height: "25px" }} />
                      </i>
                      ข้อมูลบัญชี
                    </a>
                  </li>

                  <li style={{ cursor: "pointer" }}>
                    <a
                      className="nav-sidemenu-selection"
                      style={{ color: sideNavSelection === 2 ? "#4d6368 " : "" }}
                      onClick={()=>{handleSideNavPage(0,2,2)}}
                    >
                      <i>
                        <BadgeIcon style={{ width: "25px", height: "25px" }} />
                      </i>
                      รายละเอียดผู้ใช้
                    </a>
                  </li>

                  <li style={{
                      cursor: operatorStatus? "pointer" : "not-allowed",
                      pointerEvents: operatorStatus? "auto" : "none",
                      opacity: operatorStatus? 1 : 0.5,
                  }}>
                    <a
                      className="nav-sidemenu-selection"
                      style={{ color: sideNavTree === 1? "#4d6368 " : "" }}
                      onClick={()=>{handleSideNavPage(1,articlePage,3)}}
                    >
                      <i>
                        <FaUserTie style={{ width: "25px", height: "25px" }} />
                      </i>
                      ผู้ดำเนินการ
                    </a>
                  </li>
                  {/* Child articlePage 3 */}
                  {sideNavSelection === 3 ||sideNavSelection === 3.1||sideNavSelection === 3.2||sideNavSelection === 3.3 ? (<div>
                    <li style={{ cursor: "pointer" }}>
                      <a
                        className="nav-sidemenu-selection"
                        style={{ color: sideNavSelection === 3.1 ? "#4d6368 " : "",marginLeft:20}}
                        onClick={()=>{handleSideNavPage(0,3.1,3.1)}}
                      >
                        <i>
                          <GiDeliveryDrone style={{ width: "25px", height: "25px" }} />
                        </i>
                        โดรน
                      </a>
                    </li>
                    <li style={{ cursor: "pointer" }}>
                      <a
                        className="nav-sidemenu-selection"
                        style={{ color: sideNavSelection === 3.2 ? "#4d6368 " : "" ,marginLeft:20}}
                        onClick={()=>{handleSideNavPage(0,3.2,3.2)}}
                      >
                        <i>
                          <MdSettingsRemote style={{ width: "25px", height: "25px"}} />
                        </i>
                        อุปกรณ์ควบคุม
                      </a>
                    </li>
                    <li style={{ cursor: "pointer" }}>
                      <a
                        className="nav-sidemenu-selection"
                        style={{ color: sideNavSelection === 3.3 ? "#4d6368 " : "",marginLeft:20 }}
                        onClick={()=>{handleSideNavPage(0,3.3,3.3)}}
                      >
                        <i>
                          <LiaUsersSolid style={{ width: "25px", height: "25px"}} />
                        </i>
                        นักบินในสังกัด
                      </a>
                    </li>

                  </div>) : null}
                  {/* Child articlePage 3 */}

                

                  <li style={{ 
                    cursor: pilotStatus? "pointer" : "not-allowed",
                    pointerEvents: pilotStatus? "auto" : "none",
                    opacity: pilotStatus? 1 : 0.5,
                   }} >
                    <a
                      className="nav-sidemenu-selection"
                      style={{ color: sideNavSelection === 4 ? "#4d6368 " : "" }}
                      onClick={()=>{handleSideNavPage(0,4,4)}}
                    >
                      <i>
                        <GiDeliveryDrone style={{ width: "25px", height: "25px" }} />
                      </i>
                      นักบิน
                    </a>
                  </li>
                  <li style={{
                      cursor: operatorStatus? "pointer" : "not-allowed",
                      pointerEvents: operatorStatus? "auto" : "none",
                      opacity: operatorStatus? 1 : 0.5,
                   }}>
                    <a
                      className="nav-sidemenu-selection"
                      style={{ color: sideNavTree === 2 ? "#4d6368 " : "" }}
                      onClick={()=>{handleSideNavPage(2,articlePage,5)}}
                    >
                      <i>
                        <GiPlanetConquest style={{ width: "25px", height: "25px" }} />
                      </i>
                      สถานะปฏิบัติการ
                    </a>
                  </li>
                   {/* Child articlePage 4 */}
                   {sideNavSelection === 5 ||sideNavSelection === 5.1||sideNavSelection === 5.2 ? (<div>

                    <li style={{ cursor: "pointer" }}>
                    <a
                      className="nav-sidemenu-selection"
                      style={{ color: sideNavSelection === 5.1 ? "#4d6368 " : "",marginLeft:20 }}
                      onClick={()=>{handleSideNavPage(0,5.1,5.1)}}
                    >
                      <i>
                        <IoNewspaper style={{ width: "25px", height: "25px" }} />
                      </i>
                      ปฏิบัติการของฉัน
                    </a>
                  </li>

                  <li style={{ cursor: "pointer" }}>
                    <a
                      className="nav-sidemenu-selection"
                      style={{ color: sideNavSelection === 5.2 ? "#4d6368 " : "" ,marginLeft:20}}
                      onClick={()=>{handleSideNavPage(0,5.2,5.2)}}
                    >
                      <i>
                        <MdFolderSpecial style={{ width: "25px", height: "25px" }} />
                      </i>
                      ปฏิบัติการพิเศษ
                    </a>
                  </li>

                    </div>) : null}
                  {/* Child articlePage 4 */}
                 
             

                  <li style={{ 
                      cursor: operatorStatus||pilotStatus? "pointer" : "not-allowed",
                      pointerEvents: operatorStatus||pilotStatus? "auto" : "none",
                      opacity: operatorStatus||pilotStatus? 1 : 0.5,
                   }}>
                    <a
                      className="nav-sidemenu-selection"
                      style={{ color: sideNavSelection === 6 ? "#4d6368 " : "" }}
                      onClick={()=>{handleSideNavPage(0,6,6)}}
                    >
                      <i>
                        <PiCertificateDuotone style={{ width: "25px", height: "25px" }} />
                      </i>
                      จัดการใบอนุญาต
                    </a>
                  </li>

                  <li style={{ cursor: "pointer" }} >
                    <a
                      className="nav-sidemenu-selection"
                      onClick={handleLogout}
                    >
                      <i>
                        <LogoutIcon style={{ width: "25px", height: "25px" }} />
                      </i>
                      ออกจากระบบ
                    </a>
                  </li>

                </ul>
              </div>
            </div>

            <article className="article-content">
              {corporation !== undefined ? (
                <>
                  {articlePage === 1 && (
                    <Userpage data={corporation} dronedata={droneData} />
                  )}
                  {articlePage === 2 && <UserInformation data={corporation} />}
                  {articlePage === 3.1 && <DroneList data={corporation} dronedata={droneData} />}
                  {articlePage === 3.2 && <RemoteID_List data={corporation} />} 
                  {articlePage === 3.3 && <AffiliatedPilot data={corporation} />}
                  {articlePage === 4 && <PilotManagement data={corporation} />} 
                  {articlePage === 5.1 && <MyOperation data={corporation} />}
                  {articlePage === 5.2 && <SpecialOperation data={corporation} />} 
                  {articlePage === 6 && <CertificateManager />}
                </>
              ) : (
                <>
                  {articlePage === 1 && (
                    <Userpage data={data} dronedata={droneData} />
                  )}
                  {articlePage === 2 && <UserInformation data={data} />}
                  {articlePage === 3.1 && <DroneList data={data} dronedata={droneData} />}
                  {articlePage === 3.2 && <RemoteID_List data={corporation} />} 
                  {articlePage === 3.3 && <AffiliatedPilot data={corporation} />}
                  {articlePage === 4 && <PilotManagement data={corporation} />} 
                  {articlePage === 5.1 && <MyOperation data={corporation} />}
                  {articlePage === 5.2 && <SpecialOperation data={corporation} />} 
                  {articlePage === 6 && <CertificateManager />}
                </>
              )}
            </article>
          </div>


          <Static_modal
            modalwaiting={modalToggle.modalwait}
            modalErr={modalToggle.modalErr}
            modalSuccess={modalToggle.modalSuccess}
            modalDenied={modalToggle.modalDenied}
            textBody={textBody}
            getHandle={handleClose_Modal}
          />
          <Modal
            show={shownoregisdrone}
            onHide={() => {
              setShownoregisdrone(false);
            }}
            className="font-cen"
            centered
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title>แจ้งเตือน</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <>
                <p style={{ color: "red" }}>คุณยังไม่ได้ขึ้นทะเบียนโดรน</p>
              </>
            </Modal.Body>
          </Modal>
        </div>
      )}
    </div>
  );
}
export default ProfileUser;
